// extracted by mini-css-extract-plugin
module.exports = {"section":"_2Z7Yj","results":"mNFDz"};